import { Controller } from '@hotwired/stimulus'

// Acordeón de criterios de «Cómo evaluamos» en la portada de cuentas (ENH-RNK-7023). Hay
// siempre uno abierto y avanza solo cuando termina la animación (invisible) de su barra, de
// 4 s. Pasar el ratón o el foco lo pausa, igual que salir de la pantalla; elegir uno a mano lo
// abre y para el avance del todo. Con «reducir movimiento» no hay barra ni avance.
export default class extends Controller {
  static targets = ['criterio', 'boton', 'panel']
  static values = { abierto: Number }

  connect () {
    this.pausas = new Set()
    this.alTerminar = this.alTerminar.bind(this)
    this.element.addEventListener('animationend', this.alTerminar)
    if (window.IntersectionObserver) {
      this.observador = new IntersectionObserver((entradas) => {
        this.pausar('fuera', !entradas.some((entrada) => entrada.isIntersecting))
      }, { threshold: 0.4 })
      this.observador.observe(this.element)
    }
  }

  disconnect () {
    this.element.removeEventListener('animationend', this.alTerminar)
    this.observador?.disconnect()
  }

  elegir (evento) {
    this.abiertoValue = this.botonTargets.indexOf(evento.currentTarget)
    this.pausar('elegido', true)
  }

  pausarConRaton () { this.pausar('raton', true) }
  seguirConRaton () { this.pausar('raton', false) }
  pausarConFoco () { this.pausar('foco', true) }
  seguirConFoco () { this.pausar('foco', false) }

  pausar (motivo, activa) {
    if (activa) this.pausas.add(motivo)
    else this.pausas.delete(motivo)
    this.element.classList.toggle('is-pausado', this.pausas.size > 0)
  }

  alTerminar (evento) {
    if (!evento.target.classList.contains('rnk-PortadaCuentas_CriterioProgreso')) return

    this.abiertoValue = (this.abiertoValue + 1) % this.criterioTargets.length
  }

  abiertoValueChanged (abierto) {
    this.criterioTargets.forEach((criterio, indice) => {
      const activo = indice === abierto
      criterio.classList.toggle('is-abierto', activo)
      this.botonTargets[indice].setAttribute('aria-expanded', activo)
      this.panelTargets[indice].inert = !activo
    })
  }
}
